import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { CmsComponentData } from '@spartacus/storefront';
import { Observable } from 'rxjs';
import { CmsNavigationComponent } from '../../../../core/model';
import { NavigationService } from '../../../navigation/cms-libs/navigation';
import { NavigationNode } from '../../../navigation/cms-libs/navigation/navigation-node.model';

@Component({
  templateUrl: './main-content.component.html',
  styleUrls: ['./main-content.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class MainContentComponent implements OnInit {
  node$: Observable<NavigationNode> = this.service.createNavigation(this.componentData.data$);

  constructor(
    private componentData: CmsComponentData<CmsNavigationComponent>,
    private service: NavigationService
  ) {}

  ngOnInit() {}
}
